<template>
  <div>
    <div v-if="updateData">
    </div>
    <b-row>
      <b-col sm="12" class="component-margin" v-if="editable">
        <b-button size="sm" @click="editModal(null)" variant="danger">{{$t('shippingFee.addRecord')}}</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3">
        <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                :items="items" :fields="fields"
                :current-page="currentPage" :per-page="perPage"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
          <template slot="shippingCost" slot-scope="row">
            <label size="sm" class="table-label">{{formatPrice(row.value)}}</label>
          </template>
          <template slot="update" slot-scope="row">
            <b-button size="sm" @click="editModal(row)" variant="warning">{{$t('shippingFee.update')}}</b-button>
          </template>
          <template slot="delete" slot-scope="row">
            <b-button size="sm" @click="deleteRowConfirm(row)" variant="secondary">{{$t('shippingFee.delete')}}</b-button>
          </template>
        </b-table>
      </b-col>
      <b-modal ref="deleteRowConfirm" @ok="deleteRow" hide-header>
        <div class="text-center">{{confirmMessage}}</div>
      </b-modal>
      <b-modal ref="editModal" :title="$t('shippingFee.updateTitle')" @ok="handleOk">
        <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="重量(Kg)" label-for="fromWeight">
          <b-form-input size="sm" id="fromWeight" v-model="editItem.fromWeight" type="text"/>
        </b-form-group>
        <!-- <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" :label="$t('shippingFee.table.toWeight')" label-for="toWeight">
          <b-form-input size="sm" id="toWeight" v-model="editItem.toWeight" type="text"/>
        </b-form-group> -->
        <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" :label="$t('shippingFee.table.shippingCost')" label-for="shippingCost">
          <b-form-input size="sm" id="shippingCost" v-model="editItem.shippingCost" type="text"/>
        </b-form-group>
      </b-modal>
      <b-modal ref="confirmMessage" ok-only hide-header>
        <div class="text-center"><label>{{confirmMessageOkOnly}}</label></div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    editable: {
      default: false,
    },
    feeType: {
      default: '',
    },
    version: {
      default: 0,
    },
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'fromWeight',   label: '重量(Kg)',   sortable: true, variant: 'base', class: 'table-rw8' },
        // { key: 'toWeight',     label: this.$i18n.t('shippingFee.table.toWeight'),     sortable: true, variant: 'base', class: 'table-rw8' },
        { key: 'shippingCost', label: this.$i18n.t('shippingFee.table.shippingCost'), sortable: true, variant: 'warning', class: 'table-rw8' },
      ],
      currentPage: 1,
      perPage: 999,
      totalRows: 0,
      sortBy: 'fromWeight',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      editItem: {},
      updateItem: false,
      confirmMessage: '',
      confirmMessageOkOnly: '',
    };
  },
  beforeMount() {
    if (this.editable === true) {
      this.fields.push({ key: 'update', label: this.$i18n.t('shippingFee.table.update'), sortable: false, variant: 'success', class: 'table-cw4' });
      this.fields.push({ key: 'delete', label: this.$i18n.t('shippingFee.table.delete'), sortable: false, variant: 'success', class: 'table-cw4' });
    }
  },
  // created() {
  //   console.log("test");
  //   api.getShippingFees(this.feeType, (items) => {
  //     this.items = items;
  //     this.totalRows = this.items.length;
  //   });
  // },
  computed: {
    updateData() {
      // SLC担当の場合
      // console.log("## 1: " + this.feeType + "/" + this.version);
      if(this.version === 1){
        // console.log("## 2: " + this.feeType);
        api.getShippingFees(this.feeType, (items) => {
          this.items = items;
          this.totalRows = this.items.length;
        });
        this.version = this.version + 1;
        // console.log("## 3: " + this.feeType + "/" + this.version);
      }
      return false;
    },
  },
  methods: {
    editModal(row) {
      this.editItem = {};
      this.updateItem = false;
      if (row !== null) {
        // Object.assign(this.editItem , row.item);
        this.editItem =  Object.assign({}, this.editItem , row.item);
        this.updateItem = true;
      }
      this.$refs.editModal.show();
    },
    handleOk() {
      if (this.updateItem === false) {
        api.registerShippingFees(this.feeType, this.editItem, (items) => {
          this.items = items;
          this.totalRows = this.items.length;

          this.confirmMessageOkOnly = '登録完了しました。';
          this.$refs.confirmMessage.show();
        });
      } else {
        api.updateShippingFees(this.feeType, this.editItem, (items) => {
          this.items = items;
          this.totalRows = this.items.length;

          this.confirmMessageOkOnly = '更新完了しました。';
          this.$refs.confirmMessage.show();
        });
      }
    },
    deleteRowConfirm(row) {
      Object.assign(this.editItem , row.item);
      this.confirmMessage = utility.format(this.$i18n.t('shippingFee.message.deleteConfirm'), row.item.fromWeight);
      this.$refs.deleteRowConfirm.show();
    },
    deleteRow() {
      api.deleteShippingFees(this.feeType, this.editItem, (items) => {
        this.items = items;
        this.totalRows = this.items.length;

        this.confirmMessageOkOnly = '削除完了しました。';
        this.$refs.confirmMessage.show();
      });
    }
  },
};

</script>
<style>
.component-margin {
  margin-bottom: 1rem;
}

th.table-base {
  background-color: aliceblue!important;
}
td.table-success{
  background-color: rgba(40,167,69,.25);
}
td.table-warning{
  background-color: #ffeeba59;
}
@media (min-width: 768px) {
  .table-label { margin-top: 0.3rem; margin-bottom: 0.3rem; }
  .table-linput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: left; }
  .table-rinput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: right; }
  .table-lw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:left; }
  .table-lw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:left; }
  .table-lw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:left; }
  .table-lw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:left; }
  .table-lw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:left; }
  .table-lw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:left; }
  .table-lw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:left; }
  .table-lw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:left; }
  .table-lw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:left; }
  .table-lw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:left; }
  .table-lw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:left; }
  .table-lw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:left; }
  .table-lw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:left; }
  .table-lw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:left; }
  .table-lw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:left; }
  .table-lw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:left; }
  .table-lw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:left; }
  .table-lw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:left; }
  .table-lw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:left; }
  .table-rw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:right; }
  .table-rw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:right; }
  .table-rw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:right; }
  .table-rw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:right; }
  .table-rw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:right; }
  .table-rw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:right; }
  .table-rw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:right; }
  .table-rw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:right; }
  .table-rw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:right; }
  .table-rw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:right; }
  .table-rw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:right; }
  .table-rw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:right; }
  .table-rw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:right; }
  .table-rw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:right; }
  .table-rw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:right; }
  .table-rw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:right; }
  .table-rw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:right; }
  .table-rw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:right; }
  .table-rw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:right; }
  .table-cw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:center; }
  .table-cw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:center; }
  .table-cw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:center; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center; }
  .table-cw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:center; }
  .table-cw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:center; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center; }
  .table-cw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:center; }
  .table-cw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:center; }
  .table-cw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:center; }
  .table-cw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:center; }
  .table-cw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:center; }
  .table-cw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:center; }
  .table-cw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:center; }
  .table-cw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:center; }
  .table-cw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:center; }
  .table-cw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:center; }
  .table-cw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:center; }
  .table-cw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:center; }
}
</style>
